import type { SVGProps } from 'react';

// Iconsax 24-grid asset rescaled to a 28 viewBox (coords ×7/6): stroke must be
// 1.75 (= 1.5 × 7/6) to match the lucide icons' line weight at equal size.
// Y coordinates affine-corrected so the painted ink spans exactly the same
// vertical band as lucide Calendar/Settings — verified by the measured-bounds
// table in the Icons/HeaderNavIcons story.
const SvgThreeDCube = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.0727 2.6049L22.6677 6.7099C23.5544 7.1894 23.5544 8.5577 22.6677 9.0372L15.0727 13.1422C14.396 13.5047 13.6027 13.5047 12.926 13.1422L5.33102 9.0372C4.44435 8.5577 4.44435 7.1894 5.33102 6.7099L12.926 2.6049C13.6027 2.2424 14.396 2.2424 15.0727 2.6049Z"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.21232 11.8084L11.2707 15.352C12.1457 15.7965 12.7057 16.697 12.7057 17.6794V24.3689C12.7057 25.3397 11.6907 25.9595 10.8273 25.5267L3.76898 21.9831C2.89398 21.5387 2.33398 20.6383 2.33398 19.6559V12.9662C2.33398 11.9955 3.34898 11.3757 4.21232 11.8084Z"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7883 11.8084L16.7299 15.352C15.8549 15.7965 15.2949 16.697 15.2949 17.6794V24.3689C15.2949 25.3397 16.3099 25.9595 17.1733 25.5267L24.2316 21.9831C25.1066 21.5387 25.6666 20.6383 25.6666 19.6559V12.9662C25.6666 11.9955 24.6516 11.3757 23.7883 11.8084Z"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgThreeDCube;
